import userApi from '@/api/user.api'
import ETC from '@/config/etc.config'
// import 'jpasc'
const sc = window.sc
function loadJsasc(src) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.onload = () => {
      resolve()
    }
    script.onerror = (err) => {
      reject(err)
    }
    script.src = src
    document.getElementsByTagName('head')[0].appendChild(script)
  })
}

export function zuizhuhaiInit() {
  return new Promise(async (resolve, reject) => {
    console.log('zuizhuhaiInit~~~~zuizhuhaiInit', sc)
    await loadJsasc()
    userApi.bestzhuhaiAuthGetInitCode()
      .then(res => {
        if (res.init_code) {
          sc.config({
            debug: false, // 是否开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来
            appId: '6bbcefb2896f41be9476bf8f8ef0c3be',
            initCode: res.init_code,
            nativeApis: ['userAuth']
          })
          sc.ready(() => {
            sc.userAuth({ appId: '6bbcefb2896f41be9476bf8f8ef0c3be' }, res => {
              /*
               sc.userAuth会首先判断用户是否登录，若没有登录，则会主动调起登录窗口，无需在此调用 isLogin 和 login 接口
               */
              if (res.code === 0) {
                //    用户同意授权
                const requestCode = res.data.requestCode
                userApi.bestzhuhaiAuthLogin(requestCode).then(info => {
                  localStorage.setItem(ETC.LOCAL_STORAGE_KEY.TOKEN, info.token)
                  localStorage.setItem(ETC.LOCAL_STORAGE_KEY.ETC_UID, info.uid)
                  localStorage.setItem(ETC.LOCAL_STORAGE_KEY.PAHCZ_OPENID, info.third_code)
                  localStorage.setItem(ETC.LOCAL_STORAGE_KEY.UUID, info.uid)
                  resolve(true)
                  // 你自己的业务逻辑
                })
              } else {
                /*
                用户拒绝授权或其它失败情况
                code: -1 默认失败
                code: -10001    没有初始化JSSDK
                code: -10002    用户点击拒绝授权
                code: -10003    用户未登录
                */
                console.warning(res.message)
                reject(res.messag)
              }
            })
          })
          sc.error((res) => {
            console.error({ res })
            reject(res)
          })
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}
